// extracted by mini-css-extract-plugin
export default {"formContainer":"DeleteBillingModal_formContainer__0fDlH","error":"DeleteBillingModal_error__LA2pH"};